module.exports = __webpack_public_path__ + "img/arrow-icon-big.89312f96.svg";